import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CalendarEventAttendeeResponseStatus } from '@demind-inc/core';

import { calendarApi, CalendarEventRespondReq } from '../api';

export interface UseRespondCalendarEventParams {
  userId: string;
  calendarId: string;
  eventId: string;
  responseStatus: Extract<
    CalendarEventAttendeeResponseStatus,
    'accepted' | 'tentative' | 'declined'
  >;
  comment?: string;
  sendResponse?: boolean;
}

export function useRespondCalendarEvent() {
  const queryClient = useQueryClient();

  const respondCalendarEventMutation = useMutation({
    mutationFn: ({
      userId,
      calendarId,
      eventId,
      responseStatus,
      comment,
      sendResponse,
    }: UseRespondCalendarEventParams) => {
      const requestPayload: CalendarEventRespondReq = {
        responseStatus,
        ...(comment !== undefined ? { comment } : {}),
        ...(sendResponse !== undefined ? { sendResponse } : {}),
      };

      return calendarApi.respondCalendarEvent(userId, calendarId, eventId, requestPayload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.calendar.events'] });
    },
  });

  return {
    respondCalendarEvent: respondCalendarEventMutation.mutateAsync,
    isResponding: respondCalendarEventMutation.isPending,
    ...respondCalendarEventMutation,
  };
}
